import { render } from "./Towers.vue?vue&type=template&id=8fa0a538&scoped=true"
import script from "./Towers.vue?vue&type=script&lang=js"
export * from "./Towers.vue?vue&type=script&lang=js"

import "./Towers.vue?vue&type=style&index=0&id=8fa0a538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa0a538"]])

export default __exports__